import { yupResolver } from '@hookform/resolvers/yup';
import { last } from 'lodash';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import handleCreateUser from '../../../../services/apollo/func/handle/handleCreateUser';

export const getSchema = () => {
  const schema = yup.object().shape({
    firstName: yup.string().trim().required(''),
    lastName: yup.string().trim().required(''),
    email: yup.string().trim().required(''),
    role: yup.object().shape({}).required(''),
  });
  return schema;
};

export const getForm = schema => useForm({
  mode: 'onChange',
  defaultValues: {
    firstName: '',
    lastName: '',
    email: '',
    role: undefined,
  },
  resolver: yupResolver(schema),
});

export const getRoleOption = () => [
  {
    label: 'Admin',
    value: 'ADMIN',
  },
  {
    label: 'Power user',
    value: 'POWER_USER',
  },
  {
    label: 'Light user',
    value: 'LIGHT_USER',
  },
];

export const createUser = async (data) => {
  try {
    const {
      email, firstName, lastName, role,
    } = data;
    const input = {
      email,
      firstName,
      lastName,
      role: role.value,
    };
    const createUser = await handleCreateUser({ input });
    return createUser;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};
